"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function getFirstGroup(apiClient) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var groups, firstGroup;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiClient.getGroupList()];
                case 1:
                    groups = (_a.sent()).data.groups;
                    firstGroup = groups[groups.length - 1];
                    return [2 /*return*/, firstGroup];
            }
        });
    });
}
exports.getFirstGroup = getFirstGroup;
//# sourceMappingURL=helpers.js.map